/*
 * @Author: your name
 * @Date: 2022-01-28 15:32:26
 * @LastEditTime: 2024-11-21 21:11:58
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\filterField\BsyFilterText\index.jsx
 */

import React from 'react'
import { BsyUtils } from '../../../utils/Utils';
import BsyMsgBubble from '../../BsyMsgBubble';
import BsySelect from '../../BsySelect';
import BsySelectCheckBox from '../../BsySelectCheckBox';
import BsyFilterBase from '../BsyFilterBase';

import './index.css'
import { BsyConfig } from '../../../global/BsyConfig';

export class BsyFilterFlowAssistFlowid extends BsyFilterBase {

    constructor(props) {
        super({
            minRow: 10,
            onStopEdit: null,
            ...props
        })
        this.state = {
            items: [],
        }
        this.dashText = null;
    }


    componentDidMount() {
        super.componentDidMount()
        this._loadFlowNode()
    }

    _loadFlowNode = () => {
        let that = this;
        let e = this.props
        if (e.fields && e.fields.length && e.fields[0].form) {
            React.axios("/dashboard/app/" + window.FX.STATIC.APPID + "/workflow/query_all_node", {
                appId: window.FX.STATIC.APPID,
                formId: e.fields[0].form,
            }).then(res => {
                BsyUtils.showAjaxTip(res.data, () => {
                    this.setState({
                        items: [...res.data.data]
                    })
                })
            }).catch(res => {
                console.error(res);
            })
        }

    }

    _getAvailableMethods = () => {
        return [BsyConfig().CONST.FILTER_METHOD.IN]
    }


    getValue = () => {
        return {
            value: this.dashText.getValue()
        }
    }

    getContext = (e) => {
        this.dashText = e;
    }

    showFlowNodeList = (event, data) => {
        if (this.showRef) {
            this.showRef.closeAlter();
            this.showRef = null;
        }
        BsyMsgBubble({
            anchor: event.currentTarget,
            contentHTML: (ref) => {
                this.showRef = ref;
                return <div className="bsy-filter-flow-node-pane">
                    <ul className="menu-pane">
                        <li className="menu-item title">
                            <span className="flow-node-name">{React.language('filter.flowNode.list')}</span>
                        </li>
                        {
                            data.item.map(item => {
                                if (item.status == 2) {
                                    return <li className="menu-item"><span className="flow-node-name">{item.name}</span><span className="flow-node-version">({item.version})</span><span className="flow-node-status">{React.language('enable')}</span></li>
                                }
                                return <li className="menu-item"><span className="flow-node-name">{item.name}</span><span className="flow-node-version">({item.version})</span> </li>
                            })
                        }

                    </ul>
                </div>
            },
            text4Cancel: null,
            text4Ok: null,
            theme: this.props.theme,
            minWidth: 220,
            width: 220,
            contentPadding: 0,
            edge: 200,
            hAdjust: 72,
            dockPosition: "left",
            leftOffset:25,
            onClose: function () {
                return !1;
            }
        })
    }

    renderCont = () => {
        let e = this
        let i = this.options;

        let val = this.getMiddleValue();

        return <BsySelectCheckBox
            theme={this.props.theme}
            hasSelectAll={true}
            allowBlank={true}
            // hasDefault={!0}
            onBeforeAsync={i.onBeforeAsync}
            textField={"name"}
            valueField={"flowId"}
            height={'34px'}
            value={val ? val.value : null}
            items={this.state.items}
            onStopEdit={e1 => {
                e.value = e.getValue()
                BsyUtils.applyFunc(e, i.onStopEdit, [{
                    value: e.getValue(),
                    valueMode: e.valueMode,
                    method: e.method,
                }, i], !1)
            }}
            getContext={this.getContext}
            onCustomItem={(e) => {

                return <>
                    <span
                    >
                        {e.name}
                    </span>
                    <i className='icon-bsy-right'
                        style={{
                            position: 'absolute',
                            right: 20,
                        }}
                        onMouseEnter={(event) => {
                            this.showFlowNodeList(event, e);
                        }}
                        onMouseLeave={(event) => {
                            this.showFlowNodeList(event, e);
                        }}
                    ></i>
                </>
            }}

        />
    }
    render() {
        return (<>
            {
                this.createTitleBar()
            }
            <div className='bsy-dash-cont' >
                {
                    this.renderCont()
                }
            </div>
        </>)
    }

}

